export { ContentSlider, type ContentSliderProps } from "./ContentSlider";
